import * as React from 'react';
import { useCombobox } from 'downshift';
import { FormField, InputBar } from '@xingternal/text-field';
import { Styled } from './auto-complete.styles';
export const AutoComplete = ({ variant, textFieldVariant, id, suggestions, value, className, inputClassName, ariaLabel, openOnFocus, onChange, onSelect, suggestionToString, innerRef, itemRenderer, ...inputRestProps }) => {
    var _a;
    const { isOpen, inputValue, highlightedIndex, openMenu, getComboboxProps, getInputProps, getMenuProps, getItemProps, getLabelProps, } = useCombobox({
        id,
        items: suggestions !== null && suggestions !== void 0 ? suggestions : [],
        inputValue: value,
        ...(suggestionToString && { itemToString: suggestionToString }),
        stateReducer: (state, { type, changes }) => {
            switch (type) {
                case useCombobox.stateChangeTypes.InputChange:
                    // We need to remove the selected item from the downshift internal state,
                    // so we can select the same item consecutively (onSelectedItemChange won't be called otherwise)
                    return { ...changes, selectedItem: undefined };
                default:
                    return changes;
            }
        },
        onSelectedItemChange: ({ selectedItem }) => {
            if (onSelect && selectedItem)
                onSelect(selectedItem);
        },
    });
    const defaultItemRenderer = (suggestionValue) => {
        const position = inputValue
            ? suggestionValue.toLowerCase().indexOf(inputValue.toLowerCase())
            : -1;
        if (position >= 0) {
            const left = suggestionValue.substring(0, position);
            const middle = suggestionValue.substring(position, position + inputValue.length);
            const right = suggestionValue.substring(position + inputValue.length);
            return (React.createElement(React.Fragment, null,
                left,
                React.createElement("strong", null, middle),
                right));
        }
        return suggestionValue;
    };
    const hasLabel = inputRestProps === null || inputRestProps === void 0 ? void 0 : inputRestProps.label;
    const autoCompleteAriaLabel = (_a = ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : inputRestProps === null || inputRestProps === void 0 ? void 0 : inputRestProps.placeholder) !== null && _a !== void 0 ? _a : '';
    const InputComponent = variant === 'inputBar' ? InputBar : FormField;
    return (React.createElement(Styled.AutoComplete, { className: className },
        hasLabel ? null : (React.createElement("label", { hidden: true, ...getLabelProps() }, autoCompleteAriaLabel)),
        React.createElement("div", { ...getComboboxProps() },
            React.createElement(InputComponent, { ...getInputProps({
                    refKey: 'innerRef',
                    className: inputClassName,
                    variant: textFieldVariant,
                    onChange: (event) => {
                        if (onChange)
                            onChange(event.target.value);
                    },
                    onFocus: () => {
                        if (openOnFocus && !isOpen)
                            openMenu();
                    },
                    ...inputRestProps,
                    ...(hasLabel && { 'aria-labelledby': undefined }),
                    ...(innerRef && { ref: innerRef }),
                }) })),
        React.createElement(Styled.Menu, { ...getMenuProps({ ...(hasLabel && { 'aria-labelledby': undefined }) }) }, isOpen &&
            (suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((item, index) => {
                const suggestionValue = suggestionToString
                    ? suggestionToString(item)
                    : item;
                return (React.createElement(Styled.MenuItem, { key: `${suggestionValue}-${index}`, "$isHighlighted": highlightedIndex === index, ...getItemProps({ item, index }) }, itemRenderer
                    ? itemRenderer(item)
                    : defaultItemRenderer(suggestionValue)));
            })))));
};
AutoComplete.displayName = 'AutoComplete';
//# sourceMappingURL=auto-complete.js.map